import React from 'react';
import { LayoutDashboard, Loader2, Lock } from 'lucide-react';

interface Props {
    /** Satz aus `keinZugriffText` (services/rechte/ansichtRechte.ts). */
    text: string;
    /** Rechte werden noch geladen: kein Urteil, nur ein ruhiger Platzhalter. */
    laedt?: boolean;
    onDashboard: () => void;
}

/**
 * Steht an der Stelle einer Ansicht, für die das Recht fehlt
 * (docs/rollensystem-plan.md §6.1) — egal, ob Menü, Link, Mitteilung oder
 * gemerkter Zustand dorthin geführt hat. Die Daten der Ansicht werden gar
 * nicht erst geladen.
 *
 * Wie `NurImBrowser` bewusst KEINE `fixed inset-0`-Fläche: die
 * Android-Zurück-Taste hält solche Flächen für Dialoge und bliebe hier stehen.
 */
export const KeinZugriff: React.FC<Props> = ({ text, laedt = false, onDashboard }) => {
    if (laedt) {
        return (
            <div className="h-full flex items-center justify-center p-6" role="status" aria-label="Rechte werden geladen">
                <Loader2 className="w-6 h-6 text-slate-400 animate-spin" />
            </div>
        );
    }
    return (
        <div data-glass-view="kein-zugriff" className="h-full overflow-y-auto flex items-center justify-center p-6 animate-fade-in">
            <div className="w-full max-w-sm bg-white rounded-2xl border border-slate-200 shadow-sm p-6 text-center">
                <div className="mx-auto mb-4 w-12 h-12 rounded-xl bg-slate-50 border border-slate-200 flex items-center justify-center">
                    <Lock className="w-6 h-6 text-slate-500" />
                </div>
                <h2 className="text-lg font-bold text-slate-800">Kein Zugriff</h2>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{text}</p>
                <div className="mt-6">
                    <button
                        type="button"
                        onClick={onDashboard}
                        className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white text-sm font-semibold px-4 py-3 transition-colors"
                    >
                        <LayoutDashboard className="w-4 h-4" />
                        Zum Dashboard
                    </button>
                </div>
            </div>
        </div>
    );
};
